import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  League,
  LeagueListResponse,
  LeagueParticipantDetail,
  LeagueParticipantsResponse,
} from '../models/league';

@Injectable({
  providedIn: 'root',
})
export class LeagueService {
  private readonly baseUrl = `${environment.apiUrl}/leagues/`;

  constructor(private http: HttpClient) {}

  list(params?: {
    search?: string;
    status?: string;
    league_type?: string;
    owner_id?: number;
    page?: number;
  }): Observable<LeagueListResponse> {
    let httpParams = new HttpParams();
    if (params) {
      Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          httpParams = httpParams.set(key, String(value));
        }
      });
    }
    return this.http.get<LeagueListResponse>(this.baseUrl, { params: httpParams });
  }

  get(id: number): Observable<League> {
    return this.http.get<League>(`${this.baseUrl}${id}/`);
  }

  create(payload: FormData): Observable<League> {
    return this.http.post<League>(this.baseUrl, payload);
  }

  update(id: number, payload: FormData): Observable<League> {
    return this.http.put<League>(`${this.baseUrl}${id}/`, payload);
  }

  publish(id: number): Observable<{ detail: string }> {
    return this.http.post<{ detail: string }>(`${this.baseUrl}${id}/publish/`, {});
  }

  cancel(id: number): Observable<{ detail: string }> {
    return this.http.post<{ detail: string }>(`${this.baseUrl}${id}/cancel/`, {});
  }

  listParticipants(
    leagueId: number,
    params?: { search?: string; page?: number; page_size?: number }
  ): Observable<LeagueParticipantsResponse> {
    let httpParams = new HttpParams();
    if (params) {
      Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          httpParams = httpParams.set(key, String(value));
        }
      });
    }
    return this.http.get<LeagueParticipantsResponse>(
      `${this.baseUrl}${leagueId}/admin-participants/`,
      { params: httpParams }
    );
  }

  addParticipant(leagueId: number, playerId: number): Observable<{ detail: string }> {
    return this.http.post<{ detail: string }>(
      `${this.baseUrl}${leagueId}/admin-participants/`,
      { player_id: playerId }
    );
  }

  removeParticipant(leagueId: number, playerId: number): Observable<{ detail: string }> {
    return this.http.request<{ detail: string }>(
      'delete',
      `${this.baseUrl}${leagueId}/admin-participants/`,
      { body: { player_id: playerId } }
    );
  }

  getParticipantDetail(leagueId: number, playerId: number): Observable<LeagueParticipantDetail> {
    const params = new HttpParams().set('player_id', String(playerId));
    return this.http.get<LeagueParticipantDetail>(
      `${this.baseUrl}${leagueId}/admin-participants/detail/`,
      { params }
    );
  }
}
